export const setSectionData = (sectionData, value, id) => {
    for (let i = 0; i < sectionData.length; i++) {
        if (sectionData[i].sectionTemplateId === id) {
            sectionData[i].rate = value
            break;
        }
    }
    return sectionData
}